import React from 'react';
import styles from './SegmentedControl.module.scss';

function SegmentedControl({ segments, activeSegment, onSegmentChange }) {
  return (
    <div className={styles.container}>
      {segments.map((segment) => (
        <button
          key={segment.id}
          className={`${styles.segment} ${activeSegment === segment.id ? styles.active : ''}`}
          onClick={() => onSegmentChange(segment.id)}
        >
          {segment.icon && <span className={styles.icon}>{segment.icon}</span>}
          {segment.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl; 